var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h1',{staticClass:"text-uppercase blue--text"},[_vm._v(" zenwhitenoise.com ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }